export default __webpack_public_path__ + "static/media/15_2.fed59e2a.jpg";